(() => {
  /* =========================
     HELPERS: CART API
     ========================= */

  const getCart = async () => {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('Impossibile leggere il carrello');
    return r.json();
  };

  const changeLine = async (lineNumber, qty, sellingPlanId) => {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(lineNumber),
        quantity: Number(qty),
        selling_plan: String(sellingPlanId)
      })
    });

    let payload = null;
    try { payload = await r.json(); } catch (_) {}

    if (!r.ok) {
      const msg = payload?.description || payload?.message || `Errore aggiornando il carrello (${r.status})`;
      throw new Error(msg);
    }
    return payload;
  };

  /* =========================
     PARSE PLANS (from Liquid)
     data-plans format:
     "123::Ogni 2 settimane||456::Ogni mese||"
     ========================= */
  const parsePlans = (str) => {
    if (!str) return [];
    return str
      .split('||')
      .map(part => {
        const [id, name] = part.split('::');
        return { id: (id || '').trim(), name: (name || '').trim() };
      })
      .filter(p => p.id);
  };

  /* =========================
     UI: ERROR / HINT
     ========================= */

  const setInlineError = (root, msg) => {
    const errBox = root.querySelector('[data-pamboo-subscribe-error]');
    if (!errBox) return;
    errBox.hidden = !msg;
    errBox.textContent = msg || '';
  };

  // Messaggio guida (al posto dell’errore tecnico Dawn)
  const showHintUnderCartErrors = () => {
    const cartErrors = document.querySelector('#cart-errors');
    if (!cartErrors) return;

    cartErrors.innerHTML = `
      <div class="cart__error-message pamboo-subscribe-hint" style="margin-top:10px;">
        Per applicare l’abbonamento selezionato, clicca su <strong>Conferma</strong>.
      </div>
    `;
  };

  const clearCartErrors = () => {
    const cartErrors = document.querySelector('#cart-errors');
    if (cartErrors) cartErrors.innerHTML = '';

    // eventuali errori riga (Dawn)
    document.querySelectorAll('.cart-item__error-text').forEach((el) => (el.textContent = ''));
    document.querySelectorAll('.cart-item__error').forEach((wrap) => wrap.classList.remove('is-active'));
  };

  /* =========================
     BUILD GROUPS (once)
     - raggruppa per set di piani
     - così 24 e 48 con piani diversi hanno select diverse
     ========================= */

  const buildGroupsOnce = (root) => {
    const groupsWrap = root.querySelector('[data-pamboo-subscribe-groups]');
    const linesDataWrap = root.querySelector('[data-pamboo-lines]');
    if (!groupsWrap || !linesDataWrap) return;

    // evita duplicati
    if (groupsWrap.childElementCount) return;

    const lineEls = Array.from(linesDataWrap.querySelectorAll('[data-line][data-plans]'));
    const lines = lineEls.map(el => {
      const line = el.getAttribute('data-line');
      const title = el.getAttribute('data-title') || '';
      const plans = parsePlans(el.getAttribute('data-plans'));
      return { line, title, plans };
    });

    // raggruppa per set piani (key = lista ids)
    const map = new Map();
    for (const l of lines) {
      const key = l.plans.map(p => p.id).join(',');
      if (!map.has(key)) map.set(key, { key, plans: l.plans, lines: [] });
      map.get(key).lines.push({ line: l.line, title: l.title });
    }

    groupsWrap.innerHTML = '';

    for (const g of map.values()) {
      const box = document.createElement('div');
      box.className = 'pamboo-subscribe-group';

      const label = document.createElement('div');
      label.className = 'pamboo-subscribe-group__label';

      const titles = g.lines.map(x => x.title).join(', ');
      label.textContent = map.size === 1 ? 'Frequenza di consegna' : `Frequenza per: ${titles}`;
      box.appendChild(label);

      const select = document.createElement('select');
      select.className = 'pamboo-subscribe-select';
      select.setAttribute('data-group-select', '');
      select.setAttribute('data-lines', g.lines.map(x => x.line).join(','));

      const ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Seleziona la frequenza…';
      select.appendChild(ph);

      for (const p of g.plans) {
        const opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.name || `Piano ${p.id}`;
        select.appendChild(opt);
      }

      // ✅ IMPORTANTISSIMO:
      // blocca gli eventi così Dawn non prova a fare update/validazione e non mostra errore tecnico
      const stop = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();

        // invece dell’errore tecnico, mostriamo l’hint
        showHintUnderCartErrors();
      };

      select.addEventListener('change', stop, true);
      select.addEventListener('input', stop, true);

      box.appendChild(select);
      groupsWrap.appendChild(box);
    }
  };

  /* =========================
     EVENT DELEGATION
     ========================= */

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-pamboo-subscribe-open]');
    const confirmBtn = e.target.closest('[data-pamboo-subscribe-confirm]');

    /* ---------- APRI MENU ---------- */
    if (openBtn) {
      const root = openBtn.closest('[data-pamboo-subscribe-smart]');
      if (!root) return;

      // pulisci eventuali errori vecchi
      setInlineError(root, '');
      clearCartErrors();

      const options = root.querySelector('[data-pamboo-subscribe-options]');
      if (options) options.hidden = false;

      // nascondi bottone open
      openBtn.hidden = true;

      // costruisci select una volta
      buildGroupsOnce(root);
      return;
    }

    /* ---------- CONFERMA ---------- */
    if (confirmBtn) {
      e.preventDefault();

      const root = confirmBtn.closest('[data-pamboo-subscribe-smart]');
      if (!root) return;

      setInlineError(root, '');
      clearCartErrors();

      confirmBtn.disabled = true;

      try {
        const groupsWrap = root.querySelector('[data-pamboo-subscribe-groups]');
        const selects = Array.from(groupsWrap.querySelectorAll('[data-group-select]'));

        // valida
        for (const s of selects) {
          if (!s.value) throw new Error('Seleziona una frequenza per ogni gruppo.');
        }

        const cart = await getCart();

        // applica per ogni gruppo (piani diversi possibili)
        for (const s of selects) {
          const planId = s.value;

          const lines = (s.getAttribute('data-lines') || '')
            .split(',')
            .map(x => Number(x))
            .filter(Boolean);

          for (const line of lines) {
            const it = cart.items[line - 1];
            const qty = it?.quantity || 1;
            await changeLine(line, qty, planId);
          }
        }

        // pulizia e refresh pagina carrello
        clearCartErrors();
        window.location.reload();

      } catch (err) {
        console.error(err);
        setInlineError(root, err?.message || 'Errore nell’attivazione dell’abbonamento.');
        confirmBtn.disabled = false;
      }
    }
  });
})();
